import { alpha } from '@mui/material/styles';
export const MuiMenuItem = (theme) => {
    const { mode, primary } = theme.palette;
    const isLight = mode === 'light';
    return {
        styleOverrides: {
            root: {
                '&:hover': {
                    backgroundColor: isLight ? primary.light : alpha(primary.main, 0.12)
                },
                '&.Mui-selected': {
                    backgroundColor: 'transparent'
                }
            }
        }
    };
};
